import classNames from 'classnames';
import React from 'react';
import { Icon } from '@material-ui/core';

export interface BadgeProps {
  /**
   * 基本CSSクラス・無効化した場合適用したいCSSクラス
   */
  className?: string;

  /**
   * 有効化した場合適用したいCSSクラス
   */
  activeClassName?: string;

  /**
   * 左側のボタンアイコン. MaterialIconsのアイコン名が入ります。
   * https://material.io/resources/icons
   */
  leftIcon?: string;
  /**
   * 右側のボタンアイコン. MaterialIconsのアイコン名が入ります。
   * https://material.io/resources/icons
   */
  rightIcon?: string;

  /**
   * アイコンのクラス
   */
  iconClassName?: string;

  /**
   * バッジのタイプ `default`, `info`, `warning`, `important`, `disabled`, `success`
   * カスタムのカラーを使用する場合は backgroundColor を指定する
   */
  type?: 'default' | 'info' | 'warning' | 'important' | 'disabled' | 'success';

  /**
   * TODO: 一旦storybookのため
   */
  label?: string;

  /**
   * 無効かどうか
   */
  disabled?: boolean;

  /**
   * 背景色. typeに該当カラーがない場合に指定する
   */
  backgroundColor?: string;

  /**
   * テキストカラーを白にする
   */
  isColorWhite?: boolean;

  /**
   * タグを押した時のアクション
   */
  onClick?: (e?: React.MouseEvent<HTMLDivElement, MouseEvent>) => any;

  /** 有効になるかどうか */
  isActive: boolean;
}

export const Badge: React.FC<BadgeProps> = ({
  className,
  activeClassName,
  leftIcon,
  rightIcon,
  iconClassName,
  label,
  type = 'default',
  disabled = false,
  backgroundColor,
  isColorWhite = false,
  onClick,
  isActive,
  children,
  ...props
}) => {
  const classes = classNames(
    'uc-tag',
    className,
    type && `uc-tag--${type}`,
    !children && 'uc-tag--no-text',
    !disabled && 'uc-tag--clickable',
    isColorWhite && 'u-text-white',
    isActive && activeClassName
  );

  return (
    <div {...props} className={classes} style={backgroundColor ? { backgroundColor } : {}} onClick={onClick}>
      {leftIcon && <Icon className={classNames('uc-tag__left-icon', iconClassName)}>{leftIcon}</Icon>}
      {label || children}
      {rightIcon && <Icon className={classNames('uc-tag__right-icon', iconClassName)}>{rightIcon}</Icon>}
    </div>
  );
};

export default Badge;
